import wixPolyfill from './wix-sdk-polyfill';

function getWixSdkOrPolyfill() {
  if (typeof window !== 'undefined' && window.Wix) {
    return window.Wix;
  }

  return wixPolyfill;
}

export default () => getWixSdkOrPolyfill();
